<template>
  <div class="modal  modal-fixed-footer " ref="modal">
    <div class="modal-content">
      <video controls ref="videoPlayer">
        <source src="https://api.sldb.lc/wp-content/uploads/2021/10/FinalOverview.mp4">
      </video>
    </div>
    <div class="modal-footer">
      <button  class="btn btn-rounded transparent grey-text text-darken-3 right modal-close">DISMISS</button>
    </div>
  </div>
</template>
<script>
import M from 'materialize-css'
export default {
  name: "VideoTutorials",
  props:{
    modalState:{
      type: String,
      default: 'closed'
    },
  },
  data () {
    return {
      modal:{
        instance: null,
        options:{
          onOpenEnd: () => {
               this.$refs.videoPlayer.play()
          },
          onCloseStart: () => {
            this.$refs.videoPlayer.pause()
            this.$refs.videoPlayer.currentTime = 0
          },
          onCloseEnd: () =>{
            this.$emit('state', 'closed')
          }
        }
      }
    }
  },
  watch:{
    modalState: function (nV) {
      if(nV === 'open' && this.modal.instance) this.modal.instance.open()
      else if(nV === 'closed' && this.modal.instance && this.modal.instance.isOpen) this.modal.instance.close ()
      else if (nV === 'open' && !this.modal.instance) {
        this.$_intiModal()
        setTimeout(() => {
          this.modal.instance.open()
        }, 300);
      }  
    }
  },
  mounted () {
    this.$_intiModal()
  },
  methods:{
    $_intiModal () {
      this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options)
    }
  }
}
</script>
<style scoped lang="scss">
.modal {
  border-radius: 12px;
  min-height: 80%;
  height: 80%;
  .modal-content {
    position: absolute !important;
    height: calc(100% - 56px) !important;
    max-height: 100% !important;
    width: 100% !important;
    padding: 16px;
    padding-bottom: 0px !important;
  }
  .modal-footer {
    border: none !important;
  }
}
video {
  border-radius: 9px;
  max-width: 100%;
  height: calc(100% - 24px);
  position: absolute;
  width: calc(100% - 30px);
  background: #000000;
}
</style>